import { Checkbox, FormControlLabel, FormGroup, Stack } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { useFormikContext } from 'formik'

export default function ValidatedCheckGroup({name, labels}: {name:string, labels: string[]}) {

    const {errors, touched, values, setFieldTouched, setFieldValue} = useFormikContext<any>()

    const handleOnCheckboxClick = (field_name: string)=>{

        if(values[name].includes(field_name)){
            setFieldValue(name, values[name].filter((value:string)=>value !== field_name))
        }else{
            const new_list = [...values[name], field_name]
            setFieldValue(name, new_list)
        }
        
    }

    return (
        <Stack direction="column" spacing={1}>

            <FormGroup
                // onChange={}
                sx={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}
            >
                {
                    labels.map((label)=>(
                        <FormControlLabel
                            sx={{color: grey[500]}}
                            key={label}
                            control={
                                <Checkbox 
                                    name={label} 
                                    sx={{
                                        color: blue[200],
                                        '&.Mui-checked':{
                                            color: blue[200]
                                        }
                                    }}
                                    onClick={()=>handleOnCheckboxClick(label)}
                                    checked={values[name].includes(label)}
                                    onBlur={()=>setFieldTouched(name)}
                                />
                            }
                            label={label}
                        />
                    ))
                }
            </FormGroup>

            {(errors[name] && touched[name]) && 
                (
                    <span className="text-left bg-error inline-block w-2 h-2 rounded-full"/>
                )
            }
            
        </Stack>
    )
}
